import {reactive, computed} from "vue";

import { resolveProperty } from "store/workflow";

const sortingDefaults = {
	column: "id",
	order: "desc"
};
export const sortingData = reactive({
	...sortingDefaults
});
export const resetSortingData = () => {
	Object.assign(sortingData, {...sortingDefaults});
};

export const getSortingColumn = () => {
	return sortingData.column;
};
export const getSortingOrder = () => {
	return sortingData.order;
};
export const setSortingColumn = (column) => {
	// @TODO: Temporary deactivated since seq= sorting by api is only supported for table columns
	console.log("Sorting has been disabled for now, since the API does not support sorting by workflowproperty values yet.");
	return;
	if (sortingData.column !== column) {
		sortingData.column = column;
		sortingData.order = "asc";

	} else {
		sortingData.order = sortingData.order === "asc" ? "desc" : "asc";
	}
};
export const isSortingColumn = (column) => {
	return sortingData.column === column;
};
export const isSortingOrder = (order) => {
	return sortingData.order === order;
};